module.exports = __webpack_public_path__ + "img/baocunpingcejieguoi_jpg_smzlpg.8a04b4e6.png";